<div id="familyJuncture" class="container">
  @if (this.linkTypeFlag) {
    <div>
      @if (!this.FlagService.flagServiceObject[3]['userdataJunctureFlag']) {
        <div class="row content">
          <div class="col-12 p-0">
            <div class="component-header __indicator">
              <h3 class="label m-0">{{ 'junctures.family.header' | translate }}</h3>
            </div>
          </div>
          <div class="col-12">
            <div class="title">
              <fa-icon class="faPropleArrows" [icon]="faPropleArrows"></fa-icon>
              <h3>{{ 'junctures.family.access' | translate }}</h3>
            </div>
            @if (this.familyCaptchaCountdown < 3) {
              <div class="col-12 input-group">
                <span class="info">{{ 'junctures.family.info' | translate: { contractorName, customerType } }}</span>
                <br>
                  <label class="form-label mt-3" for="familyMemberName">{{ 'junctures.family.name' | translate }}</label>
                  <input id="familyMemberName" class="form-control" type="text" [(ngModel)]="_familyMemberNameInput" (ngModelChange)="inputChange()" name="family-member-name" placeholder="{{ 'junctures.family.placeholder.name' | translate }}">
                  <label class="form-label" for="birthDate">{{ 'junctures.family.birthDate' | translate }}</label>
                  <div class="birth-year-selection">
                    <select class="form-select birth-year" aria-label="Birth year select" [(ngModel)]="_birthYear" (ngModelChange)="inputChange()">
                      @for (year of DataService.availableYears; track year) {
                        <option value="{{ year }}">
                          {{ year }}
                        </option>
                      }
                    </select>
                    <select class="form-select birth-month" aria-label="Birth month select" [(ngModel)]="_birthMonth" (ngModelChange)="inputChange()">
                      @for (month of generalUtils.getMonths(); track month) {
                        <option value="{{ month }}">
                          {{ ('common.month.' + month) | translate }}
                        </option>
                      }
                    </select>
                    <select class="form-select birth-day" aria-label="Birth day select" [(ngModel)]="_birthDay" (ngModelChange)="inputChange()">
                      @for (day of generalUtils.getDays() | keyvalue; track day) {
                        <option [value]="day.key">
                          {{ day.value }}
                        </option>
                      }
                    </select>
                  </div>
                </div>
              }
              @if (this.summaryFlag && this.familyCaptchaCountdown < 3) {
                <div class="d-flex summary mt-4">
                  <div class="w-100">
                    <fa-icon class="text-center me-2" [icon]="faPropleArrows"></fa-icon>
                    <div class="text">
                      <span class="name">{{_familyMemberNameInput}}</span><br>
                      <span class="date">{{_familyMemberBirthDate}}</span>
                    </div>
                  </div>
                  <div class="flex-shrink-1">
                    <button (click)="sendFamilyMember()" type="button" class="btn btn-light float-end">Ok</button>
                  </div>
                </div>
              }
              @if (!(this.familyCaptchaCountdown < 3)) {
                <div class="captcha">
                  <div class="row justify-content-md-center mb-4 mt-2">
                    <div class="col-sm-10 col-md-8 mb-1 text-center">
                      @if (this.captchaPath) {
                        <img [src]="this.captchaPath" alt="captcha image" title="captcha image">
                      }
                      @if (!this.captchaPath) {
                        <fa-icon class="faHourglass mb-3" [icon]="faHourglass"></fa-icon>
                      }
                    </div>
                    <div class="col-sm-10 col-md-8">
                      <div class="captcha-container mt-1">
                        <input id="captchaInput" class="form-control" type="text" name="captcha" placeholder="{{ 'junctures.family.placeholder.captcha' | translate }}" (ngModelChange)="captchaInputChange($event)" [(ngModel)]="_captchaInput" [attr.disabled]="this.captchaPath? null : true">
                        <button (click)="validateCaptcha()" type="button" class="btn ms-3" [ngClass]="{'disabled': !_captchaInputValid}">{{ 'common.ok' | translate }}</button>
                        @if (this.captchaPath) {
                          <button (click)="reloadCaptcha()" type="button" class="btn ms-2"><fa-icon class="faRedo" [icon]="faRedo"></fa-icon></button>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
            @if (this.FlagService.flagServiceObject[3]['userdataJunctureFlag']) {
              <div class="row feedback-module" (click)="familyJunctureClick()">
                <div class="d-flex p-0">
                  <a class="w-100">
                    <fa-icon class="text-center ms-3 me-3" [icon]="faPropleArrows"></fa-icon>
                    <div class="text">
                      <span class="top">{{ this.insurantData.employee.name }}</span><br>
                      <span class="bottom">{{ this.insurantData.employee.birthDate }}</span>
                    </div>
                  </a>
                  @if (false) {
                    <div class="flex-shrink-1">
                      <fa-icon class="faInfoCircle me-2" [icon]="faInfoCircle"></fa-icon>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    }

    @if (!this.linkTypeFlag) {
      <div>
        @if (!this.FlagService.flagServiceObject[3]['userdataJunctureFlag']) {
          <div class="row content">
            <div class="col-12 p-0">
              <div class="component-header __indicator">
                <h3 class="label m-0">{{ 'junctures.family.couponCode.header' | translate }}</h3>
              </div>
            </div>
            @if ((this.couponCaptchaCountdown < 3)) {
              <div class="d-flex summary align-center code-text-container" style="background-color: white">
                <div class="w-100 flex code-text">
                  {{ 'junctures.family.couponCode.info' | translate }}
                </div>
                <div class="w-100 flex hover-blue">
                  <fa-icon class="text-center me-2" [icon]="faStar"></fa-icon>
                  <div class="text">
                    <input id="couponCode" class="form-control" type="text" [(ngModel)]="_couponCodeInput" (ngModelChange)="checkCode()" name="coupon-code" placeholder="{{ 'junctures.family.couponCode.placeholder' | translate }}">
                    @if (errorMessage) {
                      <div class="feedback invalid-feedback"><span class="wrap">{{ errorMessage }}</span></div>
                    }
                  </div>
                  <div class="flex-shrink-1">
                    <button (click)="sendCouponCode('code')" type="button" class="btn btn-light float-end" style="margin-top: 0.6rem">{{ 'common.ok' | translate }}</button>
                  </div>
                </div>
              </div>
            }
            <div class="code-separator"></div>
            @if ((this.couponCaptchaCountdown < 3)) {
              <div class="d-flex summary align-center pointer no-code-container" (click)="sendCouponCode('none')">
                <div class="w-100 flex hover-blue">
                  <fa-icon class="text-center me-2" [icon]="faRegStar"></fa-icon>
                  <div class="text">
                    <span class="name">{{ 'junctures.family.couponCode.noCode' | translate }}</span><br>
                  </div>
                </div>
              </div>
            }
            @if (!(this.couponCaptchaCountdown < 3)) {
              <div class="captcha">
                <div class="row justify-content-md-center mb-4 mt-5">
                  <div class="col-sm-10 col-md-8 mb-1 text-center">
                    @if (this.captchaPath) {
                      <img [src]="this.captchaPath" alt="captcha image" title="captcha image">
                    }
                    @if (!this.captchaPath) {
                      <fa-icon class="faHourglass mb-3" [icon]="faHourglass"></fa-icon>
                    }
                  </div>
                  <div class="col-sm-10 col-md-8">
                    <div class="captcha-container mt-1">
                      <input id="captchaInput" class="form-control" type="text" name="captcha" placeholder="{{ 'junctures.family.couponCode.placeholder' | translate }}" (ngModelChange)="captchaInputChange($event)" [(ngModel)]="_captchaInput" [attr.disabled]="this.captchaPath? null : true">
                      <button (click)="validateCaptcha()" type="button" class="btn ms-3" [ngClass]="{'disabled': !_captchaInputValid}">{{ 'common.ok' | translate }}</button>
                      @if (this.captchaPath) {
                        <button (click)="reloadCaptcha()" type="button" class="btn ms-2"><fa-icon class="faRedo" [icon]="faRedo"></fa-icon></button>
                      }
                    </div>
                    @if (captchaMessage) {
                      <div class="feedback invalid-feedback"><span class="wrap">{{ captchaMessage }}</span></div>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        }
        @if (!(DataService.isPartneri && DataService.isKompakt())) {
          @if (this.FlagService.flagServiceObject[3]['userdataJunctureFlag']) {
            <div class="row feedback-module" (click)="familyJunctureClick()">
              <div class="d-flex p-0">
                <a class="w-100">
                  <fa-icon class="text-center ms-3 me-3" [icon]="faStar"></fa-icon>
                  <div class="text">
                    <span class="top">{{ 'junctures.family.couponCode.code' | translate }}</span><br>
                    @if (this.DataService.HIPInsuredPersonFromHIPDto.couponCode) {
                      <span class="bottom">{{this.DataService.HIPInsuredPersonFromHIPDto.couponCode}}</span>
                    }
                    @if (!this.DataService.HIPInsuredPersonFromHIPDto.couponCode) {
                      <span class="bottom">{{_couponCodeInput}}</span>
                    }
                    @if (!this.DataService.HIPInsuredPersonFromHIPDto.couponCode && this._couponCodeInput.length == 0) {
                      <span class="bottom">{{ 'junctures.family.couponCode.status' | translate }}</span>
                    }
                  </div>
                </a>
                @if (false) {
                  <div class="flex-shrink-1">
                    <fa-icon class="faInfoCircle me-2" [icon]="faInfoCircle"></fa-icon>
                  </div>
                }
              </div>
            </div>
          }
        }
      </div>
    }
  </div>
